import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=1403cc13&scoped=true&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=1403cc13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1403cc13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1403cc13')) {
      api.createRecord('1403cc13', component.options)
    } else {
      api.reload('1403cc13', component.options)
    }
    module.hot.accept("./CategoryList.vue?vue&type=template&id=1403cc13&scoped=true&", function () {
      api.rerender('1403cc13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/CategoryList.vue"
export default component.exports